import { Grid } from "@mui/material";
import { useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import MaskTextInput from "../../../../components/MaskTextInput";
import { userSlice } from "../../../../store/reducer/user";
import { authSlice } from "../../../../store/reducer/auth";
import { MaskTypes } from "../../../../utils/models";
import { omitHyphen } from "../../../../utils/dataConverter";
import SSNReviewPrompt from "../../../../components/SSNReviewPrompt";
import { RootState } from "../../../../store";

const SsnVerification = () => {
  const dispatch = useDispatch();
  let [ssn, setSsn] = useState("");
  let [open, setOpen] = useState(false);
  const socialSecurityError = useSelector((state: RootState) => state.auth.formErrors.social_security);

  return (
    <>
      <ValidatorForm
        instantValidate={false}
        onSubmit={async () => {
          setOpen(true);
        }}
      >
        <br />
        <Grid className="form-row" size={12}>
          <MaskTextInput
            ariaRequired
            label={"Social Security"}
            value={ssn}
            name="ssn"
            maskType={MaskTypes.SSN}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setSsn(omitHyphen(e.target.value));
            }}
            error={!!socialSecurityError}
            helperText={!!socialSecurityError ? socialSecurityError : undefined}
            validators={["required", "isSSN"]}
            errorMessages={["This field is required", "Invalid SSN"]}
          />
        </Grid>
        <div className="btn-container single">
          <CustomButton
            type="submit"
            variant="contained"
            disableElevation={true}
            label={"Confirm"}
            buttonSize="btn-lg"
          />
        </div>
      </ValidatorForm>
      <SSNReviewPrompt
        show={open}
        forSpouse={false}
        ssn={ssn}
        onAccept={() => {
          dispatch(authSlice.actions.resetFormErrors());
          dispatch(userSlice.actions.updateUserData({ social_security: ssn }));
          dispatch(authSlice.actions.resetError());
          dispatch(authSlice.actions.precogAutoValidateRegistrationField({
            fields: { "social_security": ssn },
            next: "/register/signup"
          }));
          setOpen(false);
        }}
        onCancel={() => setOpen(false)}
      />
    </>
  );
};


export default SsnVerification;
